import { change } from './format'
import s from './Stat.module.css'

/** One headline number, optionally against an earlier value ("+12% vs last Tuesday"). Sits in a Grid. */
export function Stat(props: { label: string; value: string; now?: number; before?: number; versus?: string; note?: string }) {
  const delta = props.now !== undefined && props.before !== undefined ? change(props.now, props.before) : null
  return (
    <div className={s.stat}>
      <div className={s.label}>{props.label}</div>
      <div className={s.value}>{props.value}</div>
      {props.versus && (
        <div className={s.delta}>
          {delta ? <span className={s[delta.direction]}>{delta.text}</span> : <span>new</span>} {props.versus}
        </div>
      )}
      {props.note && <div className={s.delta}>{props.note}</div>}
    </div>
  )
}
